import { ColsGroupedDataType } from 'app/dataTypes/reports/data/common/subsidies/grouped'
import { Entity } from './types'
import { createDynamicCountSumKey } from './create-column-keys'

export const headerCellsProps = {
  [Entity.Date]: { alignCenter: true, width: 140, rowSpan: 3 },
  [Entity.DateGhost]: { alignCenter: true, width: 0, stripPadding: true },
  [Entity.Klasses]: { alignCenter: true },
  [Entity.DayCares]: { alignCenter: true },
  [Entity.Count]: { alignCenter: true, minWidth: 90 },
  [Entity.Sum]: { alignCenter: true, minWidth: 110, borderRight: true },
  [Entity.TotalRowGhost]: { alignCenter: true, colSpan: 2, width: 0, stripPadding: true },
  [Entity.CountRow]: { alignCenter: true, minWidth: 90, borderRight: true },
  [Entity.SumRow]: { alignCenter: true, minWidth: 110 },
  [Entity.TotalRow]: { alignCenter: true, colSpan: 2, rowSpan: 2 },
}

const getHeaderCellsPropsWithColspan = (cols: ColsGroupedDataType) => {
  const dayCareColSpan = cols.dayCares.length * 2
  const klassColSpan = cols.klasses.length * 2

  const dynamicProps = Object.keys(cols).reduce((acc, classType) => {
    const key = classType as keyof ColsGroupedDataType
    const items = cols[key]

    if (items && Array.isArray(items)) {
      (items as Array<string>).forEach((title) => {
        const titleKey = `${classType}_${title}`
        acc[titleKey] = { alignCenter: true, colSpan: 2, borderRight: true }

        acc[createDynamicCountSumKey(classType as 'dayCares' | 'klasses', title, 'count')] = {
          alignCenter: true,
          minWidth: 90,
          borderRight: true,
        }
        acc[createDynamicCountSumKey(classType as 'dayCares' | 'klasses', title, 'sum')] = {
          alignCenter: true,
          minWidth: 110,
          borderRight: true,
        }
      })
    }

    return acc
  }, {} as Record<string, any>)

  return {
    ...headerCellsProps,
    ...dynamicProps,
    ...(dayCareColSpan
      ? {
        [Entity.DayCares]: {
          alignCenter: true,
          colSpan: dayCareColSpan,
          borderRight: !!klassColSpan,
        },
      }
      : {}),
    ...(klassColSpan
      ? {
        [Entity.Klasses]: {
          alignCenter: true,
          colSpan: klassColSpan,
          borderRight: true,
        },
      }
      : {}),
  }
}

export const createHeaderCellsProps = (cols: ColsGroupedDataType) => {
  return new Proxy(getHeaderCellsPropsWithColspan(cols), {
    get: function (target, property) {
      const res = target[property as string]
      if (!res) {
        return {}
      }
      return res || {}
    },
  })
}
